import { useCallback } from 'react';
import { hideAppSpinner, showAppMessage, showAppSpinner } from '@rainbow-modules/app';
import useHttpMutation from 'data/firestore/useHttpMutation';
import { BaseFormProps } from './types';
import FormFooter from './footer';
import Form from './form';
import { Container, Content } from './styled';

interface CreateFormProps extends BaseFormProps {}

const CreateForm = ({
    agentId = '',
    onRequestClose = () => {},
    onCompleted = () => {},
}: CreateFormProps) => {
    const {
        mutateAsync: createCustomer,
    } = useHttpMutation<Record<string, unknown>, Record<string, unknown>>({
        pathname: '/customers',
        method: 'POST',
        onSuccess: (response) => {
            onRequestClose();
            onCompleted(response);
        },
    });

    const handleSubmit = useCallback(
        async (values: Record<string, unknown>) => {
            try {
                showAppSpinner();
                await createCustomer({
                    body: {
                        agentId,
                        ...values,
                    },
                });
            } catch (error) {
                showAppMessage({
                    variant: 'error',
                    message: (error as Error).message,
                    timeout: 5000,
                });
            }
            hideAppSpinner();
        },
        [agentId, createCustomer],
    );

    return (
        <Container>
            <Content>
                <Form
                    id="customer-form"
                    agentId={agentId}
                    onSubmit={handleSubmit}
                />
            </Content>
            <FormFooter
                formId="customer-form"
                onCancelClick={onRequestClose}
            />
        </Container>
    );
};

export default CreateForm;
